import { useLinkTo } from '@react-navigation/native'
import { Illustrations } from 'atoms'
import { Box, Button, Heading, useBreakpointValue, VStack } from 'native-base'

export const ProductSearchEmpty = () => {
  const linkTo = useLinkTo()

  const isMobile = useBreakpointValue({ base: true, lg: false })

  return (
    <VStack
      justifyContent="center"
      alignItems="center"
      margin="auto"
      height={isMobile ? '80%' : ''}
      width={isMobile ? '274px' : ''}
      right={isMobile ? '180px' : ''}
      space={6}>
      <Box alignItems="center" mb={8}>
        <Illustrations.EmptyFolder maxH={isMobile ? 85 : 157} />
      </Box>

      <Heading
        fontSize={isMobile ? '14px' : '16px'}
        lineHeight={isMobile ? '22px' : '24px'}
        fontWeight="normal"
        color="gray.600"
        margin="auto"
        width={isMobile ? '220px' : '230px'}
        textAlign="center">
        Não encontramos a sua busca Continue navegando
      </Heading>
      <Button
        onPress={() => linkTo(`/produtos/todos`)}
        width="100%"
        color="white"
        height="40px"
        pt={isMobile ? '7px' : ''}
        alignItems="center"
        maxWidth="183px"
        bgColor="red.500"
        borderRadius={30}
        display="flex"
        pb={isMobile ? '12px' : 0}>
        Ver todos os produtos
      </Button>
    </VStack>
  )
}
